<template>
  <div class="contents" data-test="orderline-timeline">
    <ClientOnly>
      <template #fallback>
        <RevSkeleton
          v-for="index in 3"
          :key="index"
          class="mb-2"
          height="1.2rem"
          shape="rectangle"
          width="100%"
        />
        <RevSkeleton
          class="mb-2"
          height="1.2rem"
          shape="rectangle"
          width="25%"
        />
      </template>

      <RevStatusTracker
        :current-step="timelineCurrentStepKey"
        :data-qa="timelineCurrentStepKey"
        :orientation
        :steps="timelineSteps"
      >
        <template
          v-for="step in timelineSteps"
          :key="step.key"
          #[`${step.key}-date`]
        >
          {{ step.date }}
        </template>
        <template
          v-for="step in timelineSteps"
          :key="step.key"
          #[`${step.key}-details`]
        >
          {{ step.details }}
        </template>
      </RevStatusTracker>
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useClientOnlyComputedBreakpoint } from '@backmarket/utils/composables/useClientOnlyComputedBreakpoint'
import { Breakpoint } from '@backmarket/utils/dom/getCurrentBreakpoint'
import { RevSkeleton } from '@ds/components/Skeleton'
import {
  type Orientations,
  RevStatusTracker,
} from '@ds/components/StatusTracker'

import type { OrderlineTimelineStep } from '~/api/my-orders/types/OrderlineTimeline.types'

import { useOrderlineTimelineStatusTracker } from './composables/useOrderlineTimelineStatusTracker'

const props = defineProps<{
  timeline: OrderlineTimelineStep[]
}>()

const breakpoint = useClientOnlyComputedBreakpoint()

const { currentStepKey: timelineCurrentStepKey, steps: timelineSteps } =
  useOrderlineTimelineStatusTracker(props.timeline)

const orientation = computed<Orientations>(() =>
  breakpoint.value < Breakpoint.LG ? 'vertical' : 'horizontal',
)
</script>
